<template>
    <div>
        <div class="vx-row">
            <div class="vx-col xl:w-1/3 lw:w-1/2 w-full">
                <vx-card id="licenseDataDiv" class="vs-con-loading__container">
                    <table class="simple-table">

                        <tr>
                            <td class="font-semibold">Valid until:</td>
                            <td>
                                <vs-chip v-if="!moment().isAfter(moment(license.actual_end_time))" color="success">{{ moment(license.actual_end_time).format("YYYY/MM/DD HH:mm:ss") }}</vs-chip>
                                <vs-chip v-else color="danger">{{ moment(license.actual_end_time).format("YYYY/MM/DD HH:mm:ss") }}</vs-chip>
                            </td>
                        </tr>

                        <tr>
                            <td class="font-semibold">Licence check valid until:</td>
                            <td>
                                <vs-chip v-if="!moment().isAfter(moment(license.end_time))" color="success">{{ moment(license.end_time).format("YYYY/MM/DD HH:mm:ss") }}</vs-chip>
                                <vs-chip v-else color="danger">{{ moment(license.end_time).format("YYYY/MM/DD HH:mm:ss") }}</vs-chip>
                            </td>
                        </tr>

                        <tr>
                            <td class="font-semibold">Transcoders:</td>
                            <td>{{ license.transcoders }}</td>
                        </tr>

                        <tr>
                            <td class="font-semibold">GPU Transcoders:</td>
                            <td>{{ license.gpu_transcoders }}</td>
                        </tr>

                        <tr>
                            <td class="font-semibold">User management subsystem:</td>
                            <td>
                                <vs-chip v-if="license.user_management_subsystem" color="success">Yes</vs-chip>
                                <vs-chip v-else color="danger">No</vs-chip>
                            </td>
                        </tr>

                        <tr>
                            <td class="font-semibold">Billing subsystem:</td>
                            <td>
                                <vs-chip v-if="license.billing_subsystem" color="success">Yes</vs-chip>
                                <vs-chip v-else color="danger">No</vs-chip>
                            </td>
                        </tr>

                    </table>

                    <vs-divider/>

                    <vs-button style="float: left" icon-pack="feather" icon="icon-refresh-cw" color="success" class="mt-3 mr-1 vs-con-loading__container" id="refreshButton" @click="refreshLicense">Refresh license</vs-button>
                    <vs-button style="float: right" icon-pack="feather" icon="icon-clipboard" color="success" class="mt-3 mr-1" @click="copyUUID">Copy UUID</vs-button>

                    <div style="clear: both"></div>
                </vx-card>
            </div>

        </div>
    </div>
</template>
<script>

    export default {

        data() {
            return {

                license: {}
            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#licenseDataDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/license/')
                loadPromise.then(function(response) {
                    thisIns.license = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#licenseDataDiv > .con-vs-loading')
                })
            },
            refreshLicense() {
                this.$vs.loading({
                    container: '#refreshButton',
                    type: 'corners',
                    scale: 0.5
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/license/refresh')
                loadPromise.then(function() {
                    thisIns.$printSuccess('License refreshed')
                    thisIns.loadData()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#refreshButton > .con-vs-loading')
                })
            },
            copyUUID() {
                const thisIns = this
                thisIns.$copyText(this.license.uuid).then(function() {
                    thisIns.$printSuccess('Link copied to clipboard')
                }, function() {
                    alert(this.license.uuid)
                })
            }
        },
        mounted() {
            this.loadData()
        }

    }

</script>
<style lang="scss">
    #avatar-col {
        width: 10rem;
    }

    .simple-table {
        td {
            vertical-align: top;
            min-width: 240px;
            padding-bottom: .8rem;
            word-break: break-all;

            @media screen and (max-width:370px) {
                display: block;
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }

</style>
